import log from 'loglevel'
import { getReceptorTemplate } from 'src/xgenerated'

// getReceptorTemplate throws on an unknown model id, which a document's actor
// can be — fall back to the raw id rather than taking the caller down.
export const getReceptorName = (modelId: string): string => {
  try {
    const { name } = getReceptorTemplate(modelId)
    return name
  } catch (error) {
    log.warn(`Failed to load receptor name for modelId: ${modelId}`, error)
    return modelId
  }
}
